import React, { useState, useRef, useEffect } from 'react';
import { User, Settings, UserCircle, ChevronDown, LogOut, HelpCircle, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAppContext } from '../../context/AppContext';

const SettingsDropdown = ({ onSettingsClick, onMyAccountClick, onHelpClick }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const { t } = useAppContext();

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleSettingsClick = () => {
    setIsOpen(false);
    onSettingsClick();
  };

  const handleMyAccountClick = () => {
    setIsOpen(false);
    onMyAccountClick();
  };

  const handleHelpClick = () => {
    setIsOpen(false);
    if (onHelpClick) {
      onHelpClick();
    }
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={handleToggle}
        className="flex items-center text-white hover:opacity-80 transition-opacity"
        title="User Menu"
      >
        <User size={18} />
        <ChevronDown size={14} className="ml-1" />
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg border border-gray-200 z-50">
          <div className="py-1">
            <button
              onClick={handleHelpClick}
              className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
            >
              <HelpCircle size={16} className="mr-3" />
              {t('settings.help')}
            </button>
            <a
              href="https://groups.google.com/a/encoreinteractive.ca/g/panorama-announce"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
            >
              <Mail size={16} className="mr-3" />
              {t('settings.mailingList')}
            </a>
            <div className="border-t border-gray-200 my-1"></div>
            <button
              onClick={handleSettingsClick}
              className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
            >
              <Settings size={16} className="mr-3" />
              {t('settings.settings')}
            </button>
            <button
              onClick={handleMyAccountClick}
              className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
            >
              <UserCircle size={16} className="mr-3" />
              {t('settings.myAccount')}
            </button>
            <div className="border-t border-gray-200 my-1"></div>
            <Link
              to="/logout"
              className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
              onClick={() => setIsOpen(false)}
            >
              <LogOut size={16} className="mr-3" />
              {t('settings.logout')}
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default SettingsDropdown;
